var exports = {
  "l": "AttachmentMosaic.module__mosaicContainerWrapper___akljV2",
  "Y": "AttachmentMosaic.module__mosaicContainer___akljV2",
};

module.exports = exports;
